import "./index.0.css";
import { memoize } from "lodash-es";
import { vueLinkLocalStorage } from '../../../utils/vue';
const HISTORY_COLORS_STORAGE_NAME = 'uc-color-picker-history-colors';
const HISTORY_COLORS_MAX_NUM = 20;
const getVueColor = memoize(() => import(/* webpackChunkName: "vuecolor" */'vue-color'));
const __script_base__ = {
  name: 'ColorPicker',
  components: {
    'sketch-picker': () => getVueColor().then(x => x.Sketch),
    'compact-picker': () => getVueColor().then(x => x.Compact),
    'swatches-picker': () => getVueColor().then(x => x.Swatches)
  },
  data() {
    return {
      HISTORY_COLORS_MAX_NUM,
      color: '',
      activeKey: 'compact',
      historyColors: []
    };
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'bottomLeft'
    }
  },
  computed: {
    bgColor() {
      return this.color === '' ? '#00000000' : this.color;
    },
    iconColor() {
      if (this.color === '') {
        return 'gray'; // 默认没颜色，用灰色
      }
      const R = parseInt(this.color.slice(1, 3), 16);
      const G = parseInt(this.color.slice(3, 5), 16);
      const B = parseInt(this.color.slice(5, 7), 16);
      const A = parseInt(this.color.slice(7, 9), 16);
      if (A < 64) {
        return 'gray'; // 透明度越低，颜色越浅，用灰色
      }
      const g = R * 0.299 + G * 0.587 + B * 0.114;
      if (g > 170) {
        return 'gray'; // g越大，颜色越浅，用灰色
      }
      return 'white';
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.color = newVal;
      },
      immediate: true
    }
  },
  methods: {
    handleColorChange(color) {
      // #RRGGBBAA格式
      // console.log('[ColorPicker] [handleColorChange] color', color.hex8);
      this.color = color.hex8;
      this.$emit('change', color.hex8);
    },
    handleHistoryColorClick(index) {
      const color = this.historyColors[index];
      if (color) {
        // 当前块存在颜色，则选择此颜色
        this.color = color;
        this.$emit('change', color);
      }
    },
    addHistoryColor(newColor) {
      // 添加历史颜色，如果已存在则将其提前至第一位
      const colorIndex = this.historyColors.findIndex(color => color === newColor);
      if (colorIndex >= 0) {
        this.historyColors.splice(colorIndex, 1);
      }
      this.historyColors = [newColor, ...this.historyColors];
      if (this.historyColors.length > HISTORY_COLORS_MAX_NUM) {
        this.historyColors.splice(HISTORY_COLORS_MAX_NUM, this.historyColors.length - HISTORY_COLORS_MAX_NUM);
      }
      this.storeHistoryColors(this.historyColors);
    },
    loadHistoryColors() {
      const historyColorsJson = localStorage.getItem(HISTORY_COLORS_STORAGE_NAME);
      let historyColors = [];
      if (historyColorsJson) {
        try {
          historyColors = JSON.parse(historyColorsJson);
        } catch (e) {
          console.log('解析历史颜色失败！重置为空');
        }
      } else {
        this.storeHistoryColors([]);
      }
      return historyColors;
    },
    storeHistoryColors(historyColors) {
      localStorage.setItem(HISTORY_COLORS_STORAGE_NAME, JSON.stringify(historyColors));
    },
    handleVisibleChange(visible) {
      if (visible) {
        // 同步别的颜色编辑器对历史记录颜色的更改
        this.historyColors = this.loadHistoryColors();
      } else {
        if (this.color !== '') {
          // 当颜色选择器浮窗关闭且选择了颜色时，添加历史颜色
          this.addHistoryColor(this.color);
        }
      }
    },
    validate() {
      if (this.readonly) return; // 只读模式不需要校验

      const {
        color
      } = this;
      if (!color && this.required) throw new Error('此字段必填');
    }
  },
  created() {
    vueLinkLocalStorage(this, 'colorPicker', 'activeKey');
  },
  mounted() {
    this.historyColors = this.loadHistoryColors();
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('a-popover', {
    style: "" + (_vm.readonly ? 'pointer-events: none' : ''),
    attrs: {
      "trigger": "click",
      "placement": _vm.placement
    },
    on: {
      "visibleChange": _vm.handleVisibleChange
    }
  }, [_c('div', {
    staticClass: "color-picker-panel",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('a-tabs', {
    attrs: {
      "animated": false
    },
    model: {
      value: _vm.activeKey,
      callback: function ($$v) {
        _vm.activeKey = $$v;
      },
      expression: "activeKey"
    }
  }, [_c('a-tab-pane', {
    key: "sketch",
    attrs: {
      "tab": "选色"
    }
  }, [_c('sketch-picker', {
    staticClass: "color-picker-panel-sketch-picker",
    attrs: {
      "value": _vm.color
    },
    on: {
      "input": _vm.handleColorChange
    }
  })], 1), _vm._v(" "), _c('a-tab-pane', {
    key: "compact",
    attrs: {
      "tab": "36色"
    }
  }, [_c('compact-picker', {
    staticClass: "color-picker-panel-compact-picker",
    attrs: {
      "value": _vm.color
    },
    on: {
      "input": _vm.handleColorChange
    }
  })], 1), _vm._v(" "), _c('a-tab-pane', {
    key: "swatchers",
    attrs: {
      "tab": "92色"
    }
  }, [_c('swatches-picker', {
    staticClass: "color-picker-panel-swatches-picker",
    attrs: {
      "value": _vm.color
    },
    on: {
      "input": _vm.handleColorChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "color-picker-panel-history-colors"
  }, _vm._l(_vm.HISTORY_COLORS_MAX_NUM, function (index) {
    return _c('div', {
      key: index,
      class: "color-picker-panel-history-color " + (_vm.historyColors[index - 1] ? 'enabled' : ''),
      on: {
        "click": function ($event) {
          return _vm.handleHistoryColorClick(index - 1);
        }
      }
    }, [_c('div', {
      style: {
        background: _vm.historyColors[index - 1]
      }
    })]);
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "color-picker",
    attrs: {
      "title": _vm.color
    }
  }, [_c('div', {
    staticClass: "color-picker-block"
  }, [_c('div', {
    staticClass: "color-picker-color-transparent-bg"
  }, [_c('div', {
    staticClass: "color-picker-color",
    style: {
      background: _vm.bgColor
    }
  }, [!_vm.readonly ? _c('a-icon', {
    staticClass: "color-picker-icon",
    style: {
      color: _vm.iconColor
    },
    attrs: {
      "type": "down"
    }
  }) : _vm._e()], 1)])])])]);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/ColorPicker/index.vue",
  "_scopeId": "data-v-bcd69ee2"
}, typeof __script__ === 'function' ? __script__.options : __script__);